import { a as o_global } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
const events = o_global.events;
const eventQBus = o_global.eventQBus;
export {
  eventQBus,
  events
};
/*🤫*/
